import axios, { AxiosResponse, Method } from 'axios';

async function fetch<T = unknown>(method: Method, url: string, data?: unknown) : Promise<T> {
    const response: AxiosResponse = await axios.request<T>({
        method,
        url,
        data
    });

    return response ? response.data : [];
}

export default {
    async get<T = unknown>(url: string, data?: unknown) {
        return fetch<T>('get', url, data);
    }
}